import React from 'react';

import { Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { ContractDetailsContainerStyled } from './style';

type CostShippingType = {
  pricing: string;
  shippingAddress: string;
};

const CostShipping = ({ pricing, shippingAddress }: CostShippingType) => {
  return (
    <ContractDetailsContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        COST & SHIPPING
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Pricing :</Typography>
          <Typography className="value">€ {pricing}</Typography>
        </InfoRowStyled>

        <InfoRowStyled>
          <Typography className="title">Shipping Address :</Typography>
          <Typography className="value">{shippingAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ContractDetailsContainerStyled>
  );
};

export default CostShipping;
